import * as types from "../actions/ActionTypes";
import { formInitial } from "../store/InitialStore";
const deftValue = {
  uniqueId: "",
  type: "text",
  label: "",
  placeholder: "",
  isMandatory: false,
  specialvalue: "",

  options: [
    {
      optionUniqueId: "",
      label: Date.now(),
      value: "",
    },
  ],
  validationType: "string",
  validations: [
    {
      type: "required",
      params: ["Required"],
    },
  ],
  format: "",
  selectedAnswer: "",
};
export default function FormReducer(state = formInitial, action) {
  const {
    type,
    payload,
    name,
    checked,
    Checkedtype,
    value,
    index,
    id,
  } = action;

  const { formValues = [] } = state;
  switch (type) {
    case types.ADD_NEW_FIELD:
      return {
        ...state,
        formValues: [
          ...formValues,
          {
            ...deftValue,
            uniqueId: Date.now().toString(),
            options: [
              { optionUniqueId: Date.now(), value: "", label: Date.now() + 1 },
            ],
          },
        ],
      };
    case types.DELETE:
      const Del = formValues.filter((Del) => Del.uniqueId !== payload);
      return { ...state, formValues: Del };
    case types.VALUE_CHANGES:
      if (Checkedtype === "checkbox") {
        formValues.find((f) => f.uniqueId === id)[name] = checked;
      } else if (
        ["type", "placeholder", "specialvalue", "isMandatory"].includes(name)
      ) {
        formValues.find((f) => f.uniqueId === id)[name] = value;
      } else {
        formValues.find((f) => f.uniqueId === id)["label"] = value;
      }

      return { ...state, formValues: formValues };
    case types.ADD_OPTION:
      return { ...state, formValues: payload };
    case types.OPTION_VALUES:
      formValues.find((l) => l.uniqueId === id).options[index][name] = value;
      return { ...state, formValues: formValues };
    case types.OPTION_DELETE:
      formValues.find((l) => l.uniqueId === id).options.splice(index, 1);
      return { ...state, formValues: formValues };
    case types.DRAG_DROP:
      return { ...state, formValues: payload };
    case types.ADD_DUPLICATE:
      const { options = {} } = formValues[index];
      const filter = formValues.filter((f) => f.uniqueId === id)[0];
      formValues.splice(index, 0, {
        ...filter,
        uniqueId: Date.now().toString(),
        options: options.map((data, index) => ({
          optionUniqueId: (Date.now() + index).toString(),
          label: Date.now(),
          value: data.value,
        })),
      });
      return { ...state, formValues: formValues };
    case types.RESET_STATE:
      return { ...state, formValues: [] };

    case types.FORM_DETAILS:
      return { ...state, formValues: payload };
    case types.NEW_FROM:
      return { ...state, formValues: [] };
    default:
      return state;
  }
}
